<div id="single-spa-application:simulator"></div>